import { useEffect, useState } from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { Button } from "components/Button";
import { Modal } from "components/Modal";
import { PageWithNav } from "components/PageWithNav";
import { Spinner } from "components/Spinner";
import { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "components/Table";
import api from "utils/api";

export const Lessons = () => {
  const navigate = useNavigate();
  const [lessons, setLessons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteLessonId, setDeleteLessonId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const loadLessons = async () => {
    try {
      setIsLoading(true);
      const response = await api.get("/lessons");
      setLessons(response.data.lessons);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (lessonId) => {
    setDeleteLessonId(lessonId);
  };

  const confirm = async () => {
    try {
      setIsDeleting(true);
      await api.delete(`/lesson/${deleteLessonId}`);
      setDeleteLessonId(null);
      loadLessons();
    } finally {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    loadLessons();
  }, []);

  return (
    <PageWithNav>
      <Modal isOpen={!!deleteLessonId} closeModal={() => setDeleteLessonId(null)} title="Are you sure?" description="This will permanently delete this lesson">
        <div className="mt-2 flex gap-2">
          <Button size="sm" onClick={confirm} loading={isDeleting} disabled={isDeleting}>
            Confirm
          </Button>
          <Button color="secondary" size="sm" onClick={() => setDeleteLessonId(null)}>
            Cancel
          </Button>
        </div>
      </Modal>
      <h1 className="mb-5 pe-4 text-xl font-semibold text-neutral-900">Lessons</h1>

      <div className="my-4">
        <Button size="sm" onClick={() => navigate("/lessons/create")}>
          Add New Lesson +
        </Button>
      </div>

      {isLoading && (
        <div className="flex justify-center">
          <Spinner size="lg" color="primary" />
        </div>
      )}

      {!isLoading && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderCell className="w-[0%]">ID</TableHeaderCell>
              <TableHeaderCell>Name</TableHeaderCell>
              <TableHeaderCell>Created</TableHeaderCell>
              <TableHeaderCell />
            </TableRow>
          </TableHeader>
          <TableBody emptyColSpan={4}>
            {!!lessons.length &&
              lessons.map((lesson) => {
                return (
                  <TableRow key={lesson.id.toString()}>
                    <TableCell className="font-semibold">{lesson.id}</TableCell>
                    <TableCell>{lesson.name}</TableCell>
                    <TableCell>{format(lesson.created_at, "do MMM yyyy")}</TableCell>
                    <TableCell className="w-0">
                      <div className="flex gap-2">
                        <Button size="sm" onClick={() => navigate(`/lessons/manage/${lesson.id}`)}>
                          Manage
                        </Button>
                        <Button size="sm" color="danger" onClick={() => handleDelete(lesson.id)}>
                          Delete
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      )}
    </PageWithNav>
  );
};
